import { HeadLightbulbIcon } from './HeadLightbulbIcon';

/**
 * author: Michael Irigoyen
 * id A94C16AE-DBA8-4DC4-B52E-589D1605C765
 * name head-lightbulb
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-lightbulb.svg
 * tags
 */
export const HeadIdeaIcon = HeadLightbulbIcon;
export default HeadIdeaIcon